import { Button } from "@runcheetah/ui";

import { cn } from "@/lib/utils";

export interface SegmentedFilterOption<TValue extends string> {
  value: TValue;
  label: string;
}

export interface SegmentedFilterProps<TValue extends string> {
  options: readonly SegmentedFilterOption<TValue>[];
  value: TValue;
  onChange: (value: TValue) => void;
  className?: string;
}

export function SegmentedFilter<TValue extends string>({
  options,
  value,
  onChange,
  className,
}: SegmentedFilterProps<TValue>) {
  return (
    <div className={cn("inline-flex rounded-full border bg-card p-1 shadow-xs", className)}>
      {options.map((item) => (
        <Button
          key={item.value}
          type="button"
          variant={value === item.value ? "default" : "ghost"}
          size="sm"
          className="h-8 rounded-full px-4 text-xs"
          onClick={() => onChange(item.value)}
        >
          {item.label}
        </Button>
      ))}
    </div>
  );
}
